export default "__VITE_ASSET__BGPrG88L__"